export default __webpack_public_path__ + "static/media/misc-closetB-1440w.bd148498.avif";